var map = {
	"./apple-laurel-da-DK.svg": 7304,
	"./apple-laurel-de-DE.svg": 80394,
	"./apple-laurel-en-GB.svg": 76744,
	"./apple-laurel-en-US.svg": 14595,
	"./apple-laurel-es-ES.svg": 36884,
	"./apple-laurel-es-MX.svg": 40407,
	"./apple-laurel-fr-FR.svg": 70268,
	"./apple-laurel-it-IT.svg": 73202,
	"./apple-laurel-nb-NO.svg": 36801,
	"./apple-laurel-nl-NL.svg": 97144,
	"./apple-laurel-pl-PL.svg": 20848,
	"./apple-laurel-pt-BR.svg": 65084,
	"./apple-laurel-pt-PT.svg": 19488,
	"./apple-laurel-sv-SE.svg": 93857
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87083;